import rootReducer from './reducers';
import actions from './actions';
import sagas from './sagas';

const reducers = {
  booking: rootReducer,
};

export { reducers, actions, sagas };
